import React from "react";
import { default as MultiSelector } from "react-multi-select-component";

const MultiSelect = (props) => {
  const { array, value, update, label } = props;
  if (!label) label = "Selecteren...";
  if (array) {
    return (
      <MultiSelector
        overrideStrings={{
          selectSomeItems: label,
          allItemsAreSelected: "Alles is geselecteerd",
          selectAll: "Selecteer alles",
          search: "Zoeken",
          clearSearch: "Wis zoekopdracht",
        }}
        options={array}
        value={value}
        onChange={update}
        labelledBy={"Select"}
      />
    );
  } else {
    return <div></div>;
  }
};

export default MultiSelect;
